import React from "react";
import { Link } from "react-router-dom";

import { routes } from "consts";
import { Tooltip } from "react-tooltip";
import { formatDate } from "utils";
import { EXAM_STATUS, ExamStatusIds } from "consts";
import { ExamStudentAttempt } from "api/course-exams";

export const ExamAttemptStatusSquare = ({
  exam,
  courseId,
  userId,
  courseExamId,
}: {
  exam: ExamStudentAttempt;
  courseId: number;
  userId: number;
  courseExamId: number;
}) => {
  const { status, userExamId, createdDate } = exam;
  if (!createdDate)
    return (
      <>
        <span className={`h-4 w-4 rounded-full bg-blue-500`} id={`exam-attempt-status-square-${userExamId * 3}`}></span>
        <Tooltip anchorSelect={`#exam-attempt-status-square-${userExamId * 3}`}>
          Egzamin nie uzupełniony <br />
        </Tooltip>
      </>
    );
  return (
    <>
      <Link
        to={routes.COURSES_MANAGE_NESTED.USER_EXAM(courseId, courseExamId, userId, userExamId)}
        className={`h-4 w-4 rounded-full ${statusSquareClasses[status]}`}
        id={`exam-attempt-status-square-${userExamId * 3}`}
      ></Link>
      <Tooltip anchorSelect={`#exam-attempt-status-square-${userExamId * 3}`}>
        {statusSquareTooltips[status]} <br />
        {formatDate(exam.createdDate, true)}
      </Tooltip>
    </>
  );
};

const statusSquareTooltips: Record<ExamStatusIds, string> = {
  [EXAM_STATUS.PASSED]: "Egzamin zaliczony",
  [EXAM_STATUS.PASSED_NOT_PUBLISHED]: "Egzamin zaliczony (nieopublikowany)",
  [EXAM_STATUS.FAILED]: "Egzamin niezaliczony",
  [EXAM_STATUS.SKIPPED]: "Egzamin pominięty",
  [EXAM_STATUS.NOT_REVIEWED]: "Egzamin oczekuję na sprawdzenie",
  [EXAM_STATUS.FAILED_NOT_PUBLISHED]: "Egzamin niezaliczony (nieopublikowany)",
};

const statusSquareClasses: Record<ExamStatusIds, string> = {
  [EXAM_STATUS.PASSED]: "bg-emerald-500",
  [EXAM_STATUS.PASSED_NOT_PUBLISHED]: "bg-emerald-300",
  [EXAM_STATUS.FAILED]: "bg-rose-500",
  [EXAM_STATUS.SKIPPED]: "bg-gray-500",
  [EXAM_STATUS.NOT_REVIEWED]: "bg-orange-500",
  [EXAM_STATUS.FAILED_NOT_PUBLISHED]: "bg-rose-300",
};
